export type CmeType = "physician" | "non-physician";
export type CmeExportMethod = "pdf" | "email";

const CME_TYPE_IDS: CmeType[] = ["physician", "non-physician"];
const CME_EXPORT_METHOD_IDS: CmeExportMethod[] = ["pdf", "email"];

export const isCmeType = (id: string): id is CmeType =>
	CME_TYPE_IDS.includes(id as CmeType);

export const isCmeExportMethod = (id: string): id is CmeExportMethod =>
	CME_EXPORT_METHOD_IDS.includes(id as CmeExportMethod);
